import { memo } from "react";

import { LaunchPadTrackUserProgress } from "../types";
import LaunchPadTrackUsernameCell from "../Cells/UsernameCell";
import LaunchPadTrackCertificatesCell from "../Cells/CertificatesCell";
import LaunchPadTrackMissionsProgressCell from "../Cells/MissionsProgressCell";

type LaunchPadTrackItemProps = {
  user: LaunchPadTrackUserProgress;
};

const LaunchPadTrackItem = ({ user }: LaunchPadTrackItemProps) => (
  <>
    <LaunchPadTrackUsernameCell user={user} />
    <LaunchPadTrackCertificatesCell user={user} />
    <LaunchPadTrackMissionsProgressCell user={user} />
  </>
);

export default memo(LaunchPadTrackItem);
